/*
snake_case → first_name
camelCase → firstName
PascalCase → FirstName
Title Case (para títulos, con espacios) → First Name
*/
export const toPascalCase = (value: string) =>
    value
        .replace(/[-_ ]+/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join('');

export const toTitleCase = (value: string) =>
    value
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');

function isCamelCase(value: string): boolean {
  if (!value || value.includes('_') || value.includes('-') || /^\d/.test(value)) {
    return false;
  }
  
  if (value.includes('data:') || (value.includes('/') && value.includes('+'))) {
    return false;
  }
  
  return /[a-z][A-Z]/.test(value) && !value.startsWith('UUID');
}

export function toCamel(o: any): any {
  if (o === null || o === undefined) {
    return o;
  }

  if (Array.isArray(o)) {
    return o
      .map(v => toCamel(v))
      .filter(v => v !== undefined);
  } else if (o.constructor === Object) {
    return Object.keys(o).reduce((result: any, key: string) => {
      const value = toCamel(o[key]);
      if (value !== undefined) {
        const camelKey = key.replace(/_([a-z])/g, g => g[1].toUpperCase());
        result[camelKey] = value;
      }
      return result;
    }, {});
  }

  return o;
}

const FIELD_NAME_KEYS = new Set(['field', 'sort']);

function camelToSnakeString(value: string): string {
  return value.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

export function toSnake(o: any): any {
  if (o === null || o === undefined) {
    return o;
  }

  if (Array.isArray(o)) {
    return o
      .map(v => toSnake(v))
      .filter(v => v !== undefined);
  } else if (o.constructor === Object) {
    return Object.keys(o).reduce((result: any, key: string) => {
      let value = toSnake(o[key]);
      if (value !== undefined) {
        const snakeKey = camelToSnakeString(key);
        if (FIELD_NAME_KEYS.has(snakeKey) && typeof value === 'string' && isCamelCase(value)) {
          value = camelToSnakeString(value);
        }
        result[snakeKey] = value;
      }
      return result;
    }, {});
  }

  return o;
}

export function splitArray<T>(array: T[], chunkSize: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
}
